import React from 'react';
import { Box, Typography } from '@mui/material';

const looksLikeHtml = (value) =>
  typeof value === 'string' && /<\/?[a-z][\s\S]*>/i.test(value);

/** Very small sanitizer: drop script/iframe/event handlers. Admin-authored content only. */
const sanitizeHtml = (html) =>
  String(html || '')
    .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '')
    .replace(/<iframe[\s\S]*?>[\s\S]*?<\/iframe>/gi, '')
    .replace(/\son\w+=(["']).*?\1/gi, '')
    .replace(/\son\w+=([^\s>]+)/gi, '');

/**
 * Renders Quill/HTML content when present, otherwise plain text with pre-line.
 * Keeps legacy plain descriptions working.
 */
const HtmlContent = ({
  children,
  variant = 'body1',
  component,
  sx = {},
  ...typographyProps
}) => {
  const value = children == null ? '' : String(children);

  if (looksLikeHtml(value)) {
    return (
      <Box
        component={component || 'div'}
        className="html-content"
        sx={{
          fontSize: sx.fontSize || (variant === 'body1' ? { xs: '1rem', md: '1.125rem' } : undefined),
          lineHeight: sx.lineHeight || 1.8,
          color: sx.color || 'text.secondary',
          '& p': { marginTop: 0, marginBottom: 1.5 },
          '& ul, & ol': { pl: 3, mb: 1.5 },
          '& h1, & h2, & h3, & h4': { mt: 2, mb: 1 },
          ...sx,
        }}
        dangerouslySetInnerHTML={{ __html: sanitizeHtml(value) }}
        {...typographyProps}
      />
    );
  }

  return (
    <Typography
      variant={variant}
      component={component}
      sx={{ whiteSpace: 'pre-line', ...sx }}
      {...typographyProps}
    >
      {value}
    </Typography>
  );
};

export default HtmlContent;
